<script setup>
import { inject } from 'vue'
import { openReportModal } from '@/helpers/modals.js'

const props = defineProps({
  message: {
    type: Object,
    required: true
  }
})

const close = inject('close')

async function reportMessage () {
  close()

  await new Promise((resolve) => setTimeout(resolve, 300))

  openReportModal({
    messageId: props.message.messageId + '',
    source: 'chat_message',
    userId: props.message?.senderId
  })
}
</script>

<template>
  <button
    role="menuitem"
    class="flex items-center gap-2.5 px-1 py-3 w-full text-left"
    @click="reportMessage">
    <InlineSvg :src="require('@/assets/fontawesome/regular/flag.svg')" class="w-4 h-4 shrink-0"/>
    {{ $t('common.report') }}
  </button>
</template>